(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7155);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8621);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1467);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8456);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3486);
/**
 * Copyright 2021 TM9657 GmbH. All Rights Reserved.
 *
 * Custom button with red and gray variation.
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding: 0.4rem;\n    font-family: 'Mulish', sans-serif;\n    width: 100%;\n    .btn {\n        background: #4f5463;\n        color: #ffffff;\n        font-weight: 700;\n        font-size: 16px;\n        font-family: 'Mulish', sans-serif;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        text-transform: capitalize;\n        box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.2), inset 0px -2px 2px rgba(0, 0, 0, 0.15),\n            inset 0px 2px 2px rgba(255, 255, 255, 0.07);\n    }\n    .btn:hover {\n        background: #3f4451;\n        box-shadow: inset 0px -2px 2px rgba(0, 0, 0, 0.15), inset 0px 2px 2px rgba(255, 255, 255, 0.07);\n    }\n    .redBtn {\n        font-family: 'Mulish', sans-serif;\n        background-color: #d62d37;\n        font-size: 16px;\n        font-weight: 700;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        text-transform: capitalize;\n        color: #cfd7ea;\n        box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.2), inset 0px -2px 2px rgba(0, 0, 0, 0.25),\n            inset 0px 2px 2px rgba(255, 255, 255, 0.15);\n    }\n    .redBtn:hover {\n        background-color: #c0222c;\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px -2px 2px rgba(0, 0, 0, 0.25),\n            inset 0px 2px 2px rgba(255, 255, 255, 0.15);\n    }\n    .MuiButton-contained.Mui-disabled {\n        background: #262933;\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), inset 0px -2px 2px rgba(0, 0, 0, 0.15),\n            inset 0px 2px 2px rgba(255, 255, 255, 0.07);\n        border-radius: 6px;\n        color: #616776;\n        cursor: not-allowed;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    root: {
        display: "flex",
        alignItems: "center"
    },
    wrapper: {
        margin: 2,
        position: "relative"
    },
    buttonSuccess: {
        backgroundColor: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][500] */ .Z[500],
        "&:hover": {
            backgroundColor: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][700] */ .Z[700]
        }
    },
    fabProgress: {
        color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][500] */ .Z[500],
        position: "absolute",
        top: -6,
        left: -6,
        zIndex: 1
    },
    buttonProgress: {
        color: _mui_material_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"][500] */ .Z[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
});
function CustomButton(props) {
    var classes = useStyles();
    var redButton = props.redButton, loading = props.loading, disabled = props.disabled;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: classes.wrapper,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variant: "contained",
                    color: "primary",
                    classes: redButton ? {
                        root: "redBtn"
                    } : {
                        root: "btn"
                    },
                    disabled: loading || disabled,
                    onClick: props.onClick,
                    style: {
                        width: "100%"
                    },
                    children: props.children
                }),
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    size: 24,
                    className: classes.buttonProgress
                })
            ]
        })
    });
};
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div */ .ZP.div(_templateObject());


/***/ }),

/***/ 9981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_header_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8580);
/* harmony import */ var _styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_ga__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(542);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/**
 * Copyright 2021 TM9657 GmbH. All Rights Reserved.
 *
 * Template, implementation up to you.
 */ /* eslint-disable @next/next/no-img-element */ 




react_ga__WEBPACK_IMPORTED_MODULE_2__/* ["default"].initialize */ .ZP.initialize("G-3GDVS9HFRZ");
function Header(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), hover = ref[0], setHover = ref[1];
    react_ga__WEBPACK_IMPORTED_MODULE_2__/* ["default"].event */ .ZP.event({
        category: "Form",
        action: "Local Error",
        label: "Too many Requests"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        className: (_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default().header),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container mx-auto flex justify-around items-center p-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default().portal), " md:px-6 md:py-3 py-2 px-4"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://portal.ca9.io/docs",
                        target: "_blank",
                        onClick: function(e) {
                            react_ga__WEBPACK_IMPORTED_MODULE_2__/* ["default"].event */ .ZP.event({
                                category: "Docs",
                                action: "Navigation",
                                label: "Open Docs"
                            });
                        },
                        className: "".concat((_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default().docs), " text-white sm:text-2xl md:text-3xl font-bold"),
                        children: "Docs"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function(e) {
                        react_ga__WEBPACK_IMPORTED_MODULE_2__/* ["default"].event */ .ZP.event({
                            category: "Docs",
                            action: "Navigation",
                            label: "Open Default Page"
                        });
                        router.push("/");
                    },
                    className: "w-28 h-28 lg:w-40 lg:h-40 cursor-pointer",
                    onMouseEnter: function() {
                        return setHover(true);
                    },
                    onMouseLeave: function() {
                        return setHover(false);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                        href: "/",
                        children: [
                            !hover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "w-full h-full",
                                src: "/assets/logo.svg",
                                alt: ""
                            }),
                            hover && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "w-full h-full",
                                src: "/assets/logoHover.svg",
                                alt: ""
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat((_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default().portalMain), " md:px-6 md:py-3 py-2 px-4"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://portal.ca9.io",
                        target: "_blank",
                        className: "".concat((_styles_header_module_css__WEBPACK_IMPORTED_MODULE_4___default().docs), " text-white sm:text-2xl md:text-3xl font-bold"),
                        onClick: function(e) {
                            react_ga__WEBPACK_IMPORTED_MODULE_2__/* ["default"].event */ .ZP.event({
                                category: "Portal",
                                action: "Navigation",
                                label: "Open Portal"
                            });
                        },
                        children: "Portal"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 7155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(214);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-ga4/dist/index.js
var dist = __webpack_require__(9089);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@react-three/fiber/dist/react-three-fiber.esm.js + 1 modules
var react_three_fiber_esm = __webpack_require__(6135);
// EXTERNAL MODULE: ./node_modules/three/build/three.module.js
var three_module = __webpack_require__(9477);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(66);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/useGLTF.js + 3 modules
var useGLTF = __webpack_require__(8626);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/PerspectiveCamera.js + 1 modules
var PerspectiveCamera = __webpack_require__(712);
// EXTERNAL MODULE: ./node_modules/@react-three/drei/core/Clone.js
var Clone = __webpack_require__(1385);
;// CONCATENATED MODULE: ./lib/util.ts
var getAbsolute = function(input) {
    var dev = "production" !== "production";
    var url = dev ? "http://localhost:3000" : "https://ca9.io";
    return "".concat(url).concat(input);
};

;// CONCATENATED MODULE: ./components/sections/three.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 80vh;\n\n  @media screen and (max-width:600px) {\n    /* Zus\xe4tzliche Regeln f\xfcr kleinere Monitore  */\n    height: 80vh;\n    margin-top: -30vh;\n    margin-bottom: -30vh;\n  }\n  \n  .videoPrev {\n    widht: 0;\n    height: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var SCALE = 10000;
var FOV = 18;
var ASPECTRATIO = 1549 / 628;
function ThreeDBanner(props) {
    var calcAspect = function calcAspect() {
        var camera = {
            aspect: 0,
            fov: 0
        };
        camera.aspect = window.innerWidth / window.innerHeight;
        ;
        if (camera.aspect > ASPECTRATIO) {
            // window too narrow
            camera.fov = FOV;
        } else {
            // window too large
            var cameraHeight = Math.tan(three_module.MathUtils.degToRad(FOV / 2));
            var ratio = camera.aspect / ASPECTRATIO;
            var newCameraHeight = cameraHeight / ratio;
            camera.fov = three_module.MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
        }
        ;
        return camera;
    };
    var group = (0,react.useRef)();
    var glb = (0,useGLTF/* useGLTF */.L)(getAbsolute("/assets/Threejs.glb"));
    var ref = (0,react.useState)(null), texture = ref[0], setTexture = ref[1];
    var ref1 = (0,react.useState)({
        scrollX: 0,
        scrollY: 0
    }), scrollPosition = ref1[0], setPosition = ref1[1];
    var ref2 = (0,react.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    }), screenSize = ref2[0], setScreensize = ref2[1];
    var ref3 = (0,react.useState)(calcAspect()), camera = ref3[0], setCamera = ref3[1];
    var camRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var updatePosition = function updatePosition() {
            setPosition({
                scrollX: window.scrollX,
                scrollY: window.scrollY
            });
        };
        var updateSize = function updateSize() {
            setScreensize({
                width: window.innerWidth,
                height: window.innerHeight
            });
            var cam = calcAspect();
            setCamera(cam);
        };
        var video = document.getElementById("myVideo");
        if (typeof video !== "undefined" && video !== null) setTexture(new three_module.VideoTexture(video));
        window.addEventListener("scroll", updatePosition);
        window.addEventListener("resize", updateSize);
        updatePosition();
        return function() {
            window.removeEventListener("scroll", updatePosition);
            window.removeEventListener("resize", updateSize);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CanvasWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_three_fiber_esm/* Canvas */.Xz, {
                className: "canvas",
                shadows: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PerspectiveCamera/* PerspectiveCamera */.c, {
                    ref: camRef,
                    manual: true,
                    makeDefault: true,
                    aspect: camera.aspect,
                    fov: camera.fov - scrollPosition.scrollY / 200,
                    onUpdate: function(c) {
                        ;
                        c.updateProjectionMatrix();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ambientLight", {
                            color: "white",
                            intensity: 2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("directionalLight", {
                            color: "white",
                            intensity: 2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("group", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            // scale={new Vector3(-1 * (0.05 + scrollPosition.scrollY / SCALE) * (screenSize.width / getScreenWidthMult()), (0.05 + scrollPosition.scrollY / SCALE) * (screenSize.width / getScreenWidthMult()), (0.05 + scrollPosition.scrollY / SCALE) * (screenSize.width / getScreenWidthMult()))}
                            scale: new three_module.Vector3(1 + scrollPosition.scrollY / SCALE, 1 + scrollPosition.scrollY / SCALE, 1 + scrollPosition.scrollY / SCALE),
                            // rotation={[0 - scrollPosition.scrollY / ROTATE, 0, 0]}
                            ref: group
                        }, props), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("mesh", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clone/* Clone */.o, {
                                    object: glb.scene,
                                    inject: /*#__PURE__*/ (0,jsx_runtime.jsx)("meshStandardMaterial", {
                                        emissiveIntensity: 30,
                                        emissiveMap: texture,
                                        metalness: 0,
                                        roughness: 1,
                                        map: texture
                                    })
                                })
                            })
                        }))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                className: "videoPrev",
                muted: true,
                loop: true,
                id: "myVideo",
                autoPlay: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: "/assets/Website-transcode.mp4",
                    type: "video/mp4"
                })
            })
        ]
    });
};
var CanvasWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());

// EXTERNAL MODULE: ./components/sections/header.tsx
var header = __webpack_require__(9981);
// EXTERNAL MODULE: ./styles/section2.module.css
var section2_module = __webpack_require__(6184);
var section2_module_default = /*#__PURE__*/__webpack_require__.n(section2_module);
// EXTERNAL MODULE: ./components/elements/custom.button.tsx
var custom_button = __webpack_require__(2291);
// EXTERNAL MODULE: ./node_modules/react-typist/dist/Typist.js
var Typist = __webpack_require__(5346);
var Typist_default = /*#__PURE__*/__webpack_require__.n(Typist);
;// CONCATENATED MODULE: ./components/sections/section2.value.prop.tsx
/* eslint-disable @next/next/no-img-element */ /**
 * Copyright 2021 TM9657 GmbH. All Rights Reserved.
 *
 * Template, implementation up to you.
 */ 
function section2_value_prop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 5;\n  .container{\n    background: #1e2128;\n  }\n  \n  .Header{\n    font-style: normal;\n    font-size: 2.5rem;\n    line-height: 3rem;\n    /* identical to box height */\n    font-weight: 900;\n  }\n  \n    .Typist .Cursor {\n        display: inline-block;\n\n        &--blinking {\n            opacity: 1;\n            animation: blink 1s linear infinite;\n            @keyframes blink {\n                0% {\n                    opacity: 1;\n                }\n                50% {\n                    opacity: 0;\n                }\n                100% {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n"
    ]);
    section2_value_prop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var counter = 0;
function Section2(props) {
    var ref = (0,react.useState)({
        options: [
            "Digital Twin",
            "Simulations",
            "Gaming",
            "Game Development",
            "Virtual Training",
            "Industrial Planning",
            "Virtual Events",
            "Architectural Visualisation", 
        ]
    }), textOptions = ref[0], setTextOptions = ref[1];
    var ref1 = (0,react.useState)({
        val: 1,
        len: 2
    }), rand = ref1[0], setRand = ref1[1];
    var ref2 = (0,react.useState)(textOptions.options[0]), currentText = ref2[0], setCurrentText = ref2[1];
    var ref3 = (0,react.useState)(true), typing = ref3[0], setTyping = ref3[1];
    (0,react.useEffect)(function() {
        if (typing) return;
        setTyping(true);
    }, [
        typing
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section2Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "my-10 mx-3 ".concat((section2_module_default()).section2),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto flex flex-col align-middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((section2_module_default()).wrapper, " py-10 px-16 mx-auto"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "Header text- mb-10 text-3xl font-black text-center md:text-3xl  tracking-wide text-white",
                                children: [
                                    "DELIVERING YOUR ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "Header Buzzword",
                                        children: "BUZZWORDS"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "text-justify text-xl md:text-xl font-bold tracking-wide text-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (section2_module_default()).primaryColor,
                                        children: "CA9"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        className: "",
                                        children: "(Connected Authoring 9latform)"
                                    }),
                                    " is a 3D authoring tool built on and compatible with Unreal Engine, but with a strong focus on beginner friendliness with expert integration.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-center py-5 text-xl md:text-3xl font-black tracking-wide text-white",
                                children: [
                                    "The perfect fit for your.. ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    typing ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((Typist_default()), {
                                        onTypingDone: function() {
                                            setTyping(false);
                                            var option = textOptions.options[Math.floor(Math.random() * textOptions.options.length)];
                                            while(option === currentText){
                                                option = textOptions.options[Math.floor(Math.random() * textOptions.options.length)];
                                            }
                                            setCurrentText(option);
                                            setRand({
                                                val: Math.random(),
                                                len: Math.ceil(Math.random() * (option.length - 1)) / 2
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Typist_default()).Delay, {
                                                ms: 200
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (section2_module_default()).useCase + " text-xl h-10 md:text-3xl font-black",
                                                children: currentText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Typist_default()).Delay, {
                                                ms: 1000
                                            })
                                        ]
                                    }) : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-center my-4 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "w-1/2",
                                        href: "https://portal.ca9.io/",
                                        target: "blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_button/* default */.Z, {
                                            redButton: true,
                                            children: "➤➤ Start"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "w-1/2",
                                        href: "https://portal.ca9.io/license",
                                        target: "blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(custom_button/* default */.Z, {
                                            children: "➤➤ Pricing"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "justify-center my-10 flex font-semibold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/assets/spaceship.svg",
                            alt: ""
                        })
                    })
                ]
            })
        })
    });
};
var Section2Wrapper = styled_components_browser_esm/* default.div */.ZP.div(section2_value_prop_templateObject());

// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 3 modules
var Grid = __webpack_require__(9162);
// EXTERNAL MODULE: ./styles/section3.module.css
var section3_module = __webpack_require__(352);
var section3_module_default = /*#__PURE__*/__webpack_require__.n(section3_module);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 139 modules
var motion = __webpack_require__(1511);
;// CONCATENATED MODULE: ./components/sections/section3.selling.points.tsx
/**
 * Copyright 2021 TM9657 GmbH. All Rights Reserved.
 *
 * Template, implementation up to you.
 */ 
function section3_selling_points_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .sizeLimiter{\n      display: flex;\n      flex-direction: column;\n      flex-wrap: wrap;\n      align-items: center;\n      width: 125rem;\n      max-width: 100%;\n      margin: auto;\n    }\n"
    ]);
    section3_selling_points_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function Section3(props) {
    var ref = (0,react.useState)({
        1: false,
        2: false,
        3: false,
        4: false
    }), info = ref[0], setInfo = ref[1];
    var showVariant = {
        open: {
            display: "block",
            opacity: 1
        },
        closed: {
            display: "none",
            opacity: 0
        }
    };
    var rotateVariant = {
        open: {
            rotate: 180
        },
        closed: {
            rotate: 0
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SellingPointWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "".concat((section3_module_default()).section3),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sizeLimiter",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    return setInfo({
                                        1: !info[1],
                                        2: false,
                                        3: false,
                                        4: false
                                    });
                                },
                                className: "".concat((section3_module_default()).card, " p-8 m-4 relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "".concat((section3_module_default()).primaryColor, " font-black tracking-wide mb-8 text-center text-3xl px-6 "),
                                        children: [
                                            "Content ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " Universe"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-black tracking-wide my-4 text-white text-xl ",
                                        children: "All resources you might need in one place. Quality controlled, up to date and complete"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.ul */.E.ul, {
                                        className: "font-black tracking-wide my-4 text-white text-xl list-disc pl-4 mt-8",
                                        animate: info[1] ? "open" : "closed",
                                        variants: showVariant,
                                        transition: {
                                            duration: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "constantly growing store"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "quality and security control"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "local server support (enterprise)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setInfo({
                                                1: !info[1],
                                                2: false,
                                                3: false,
                                                4: false
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                            animate: info[1] ? "open" : "closed",
                                            variants: rotateVariant,
                                            transition: {
                                                duration: 0.5
                                            },
                                            src: "/assets/download.svg",
                                            alt: "",
                                            className: (section3_module_default()).button
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    return setInfo({
                                        1: false,
                                        2: !info[2],
                                        3: false,
                                        4: false
                                    });
                                },
                                className: "".concat((section3_module_default()).card, " p-8 m-4 relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "".concat((section3_module_default()).primaryColor, " font-black tracking-wide mb-8 text-center text-3xl px-6 "),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                className: "Buzzword",
                                                children: "High Speed"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " Launch"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-black tracking-wide my-4 text-white text-xl ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                className: "Buzzword",
                                                children: "No Code"
                                            }),
                                            ", lean, efficient project structure, no external experts necessary. Create and launch faster and cheaper!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.ul */.E.ul, {
                                        className: "font-black tracking-wide my-4 text-white text-xl list-disc pl-4 mt-8",
                                        animate: info[2] ? "open" : "closed",
                                        variants: showVariant,
                                        transition: {
                                            duration: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "user first without compromise"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "you logic without code"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "beginner friendly, expert suitable"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setInfo({
                                                1: false,
                                                2: !info[2],
                                                3: false,
                                                4: false
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                            animate: info[2] ? "open" : "closed",
                                            variants: rotateVariant,
                                            transition: {
                                                duration: 0.5
                                            },
                                            src: "/assets/download.svg",
                                            alt: "",
                                            className: (section3_module_default()).button
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    return setInfo({
                                        1: false,
                                        2: false,
                                        3: !info[3],
                                        4: false
                                    });
                                },
                                className: "".concat((section3_module_default()).card, " p-8 m-4 relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "".concat((section3_module_default()).primaryColor, " font-black tracking-wide mb-8 text-center text-3xl px-6 "),
                                        children: [
                                            "Fast as a ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " Rocket"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-black tracking-wide my-4 text-white text-xl ",
                                        children: [
                                            "Not rocket science but fast as a rocket. We integrate the best for you, powered by ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                className: "Buzzword",
                                                children: "Unreal Engine 5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.ul */.E.ul, {
                                        className: "font-black tracking-wide my-4 text-white text-xl list-disc pl-4 mt-8",
                                        animate: info[3] ? "open" : "closed",
                                        variants: showVariant,
                                        transition: {
                                            duration: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "handle large amounts of data"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "proven and robust foundation"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "import Unreal Engine 5 content"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setInfo({
                                                1: false,
                                                2: false,
                                                3: !info[3],
                                                4: false
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                            animate: info[3] ? "open" : "closed",
                                            variants: rotateVariant,
                                            transition: {
                                                duration: 0.5
                                            },
                                            src: "/assets/download.svg",
                                            alt: "",
                                            className: (section3_module_default()).button
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                onClick: function() {
                                    return setInfo({
                                        1: false,
                                        2: false,
                                        3: false,
                                        4: !info[4]
                                    });
                                },
                                className: "".concat((section3_module_default()).card, " p-8 m-4 relative"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "".concat((section3_module_default()).primaryColor, " font-black tracking-wide mb-8 text-center text-3xl px-6 "),
                                        children: [
                                            "Alien ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " Technology"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-black tracking-wide my-4 text-white text-xl ",
                                        children: "Available for all sorts of Technology. Starting with the normal PC, VR, AR or completely in Web without strong hardware!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.ul */.E.ul, {
                                        className: "font-black tracking-wide my-4 text-white text-xl list-disc pl-4 mt-8",
                                        animate: info[4] ? "open" : "closed",
                                        variants: showVariant,
                                        transition: {
                                            duration: 0.5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "integrated Browser Streaming"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "optimized for your hardware"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "my-4",
                                                children: "VR and AR compatible"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return setInfo({
                                                1: false,
                                                2: false,
                                                3: false,
                                                4: !info[4]
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                            animate: info[4] ? "open" : "closed",
                                            variants: rotateVariant,
                                            transition: {
                                                duration: 0.5
                                            },
                                            src: "/assets/download.svg",
                                            alt: "",
                                            className: (section3_module_default()).button
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var SellingPointWrapper = styled_components_browser_esm/* default.div */.ZP.div(section3_selling_points_templateObject());

;// CONCATENATED MODULE: ./pages/index.tsx
/**
 * Copyright 2021 TM9657 GmbH. All Rights Reserved.
 *
 * Landing, Home Page. Keep this clean and lean
 * use components where possible
 */ 





/**
 * import components
 */ 

dist/* default.initialize */.ZP.initialize("G-3GDVS9HFRZ");




//const ThreeDBanner = dynamic(() => import('@components/sections/three'));
// const Section2 = dynamic(() => import('@components/sections/section2.value.prop'));
// const Section3 = dynamic(() => import('@components/sections/section3.selling.points'));
var Section4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 587).then(__webpack_require__.bind(__webpack_require__, 3685));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3685)
            ];
        }
    }
});
var Section5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 921).then(__webpack_require__.bind(__webpack_require__, 7921));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7921)
            ];
        }
    }
});
var Section6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 279).then(__webpack_require__.bind(__webpack_require__, 7279));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7279)
            ];
        }
    }
});
var Section7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(502), __webpack_require__.e(470)]).then(__webpack_require__.bind(__webpack_require__, 7470));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7470)
            ];
        }
    }
});
var Section8 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 685).then(__webpack_require__.bind(__webpack_require__, 441));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(441)
            ];
        }
    }
});
// const Header = dynamic(() => import('@components/sections/header'));
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(664), __webpack_require__.e(222)]).then(__webpack_require__.bind(__webpack_require__, 1993));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1993)
            ];
        }
    }
});
var Preloader = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 418).then(__webpack_require__.bind(__webpack_require__, 9418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9418)
            ];
        }
    }
});

function Home(props) {
    var ref = (0,react.useState)(), timeout = ref[0], setTimeoutVar = ref[1];
    var ref1 = (0,react.useState)(true), showPre = ref1[0], setShowPre = ref1[1];
    var ref2 = (0,react.useState)({
        width: 0,
        height: 0
    }), size = ref2[0], setSize = ref2[1];
    var ref3 = (0,react.useState)(null), node = ref3[0], setNode = ref3[1];
    var ref4 = (0,react.useState)([]), stars = ref4[0], setStars = ref4[1];
    var measuredRef = (0,react.useCallback)(function(node) {
        if (node !== null) {
            setNode(node);
            setSize({
                height: node.clientHeight,
                width: node.clientWidth
            });
        }
    }, []);
    (0,react.useLayoutEffect)(function() {
        if (node) {
            var measure = function() {
                setSize({
                    height: node.clientHeight,
                    width: node.clientWidth
                });
            };
            window.addEventListener("resize", measure);
            measure();
            return function() {
                window.removeEventListener("resize", measure);
            };
        }
    }, [
        node
    ]);
    (0,react.useEffect)(function() {
        if (size.width === 0 || size.height === 0) return;
        var randomIntegerInRange = function(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        };
        var randomColor = function() {
            var int = randomIntegerInRange(1, 7);
            return int === 5 ? "#4F5463" : int === 4 ? "#6C63FF" : int === 3 ? "#C0222C" : int === 2 ? "#FFFFFF" : "#4F5463";
        };
        var stars = [];
        for(var i = 0; i < 200; i++){
            stars.push({
                x: randomIntegerInRange(0, size.width - 15).toString(),
                y: randomIntegerInRange(0, size.height).toString(),
                version: randomIntegerInRange(1, 5).toString(),
                color: randomColor()
            });
        }
        setStars(stars);
    }, [
        size
    ]);
    (0,react.useEffect)(function() {
        clearTimeout(timeout);
        setTimeoutVar(setTimeout((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowPre(false);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 2000));
        dist/* default.pageview */.ZP.pageview("/");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "keywords",
                    content: "metaverse, unreal engine 5, 3d, digital twin"
                })
            }),
            showPre ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Preloader, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: measuredRef,
                        className: "".concat((Home_module_default()).wrapper, " pb-12"),
                        children: [
                            stars.map(function(value) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Home_module_default())["star".concat(value.version)], " ").concat(Math.random() < 0.75 ? (Home_module_default()).rotating : "", " ").concat(Math.random() < 0.25 ? (Home_module_default()).scaling : ""),
                                    style: {
                                        top: "".concat(value.y, "px"),
                                        left: "".concat(value.x, "px"),
                                        background: value.color,
                                        animationDelay: "".concat(Math.random() * 2, "s")
                                    }
                                }, JSON.stringify(value));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "z-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeDBanner, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section2, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section3, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "z-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section4, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section5, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section6, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section7, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section8, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__kA9A_","rotating":"Home_rotating__Oz_i3","scaling":"Home_scaling__YZeVP","star1":"Home_star1__Ci3Yr","star2":"Home_star2__OOTfP","star3":"Home_star3__UfFJj","star4":"Home_star4__6YhkF","star5":"Home_star5___Wjb7","wrapperContainer":"Home_wrapperContainer__zbHBl","structure":"Home_structure__M_ibf","container":"Home_container__bCOhY","devProgressFull":"Home_devProgressFull__G_3kr","devProgressMobile":"Home_devProgressMobile__bW_PJ","main":"Home_main__nLjiQ","footer":"Home_footer____T7K","title":"Home_title__T09hD","description":"Home_description__41Owk","code":"Home_code__suPER","grid":"Home_grid__GxQ85","card":"Home_card___LpL1","logo":"Home_logo__27_tb"};

/***/ }),

/***/ 8580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__n6agz","portal":"header_portal__VD7WE","portalMain":"header_portalMain__8cIUg","docs":"header_docs__3PWBo","container":"header_container__W0aRT","glowingStar":"header_glowingStar___HZhz","glowingSmallStar":"header_glowingSmallStar__tX6QE"};

/***/ }),

/***/ 6184:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"section2_primaryColor__j4XQE","downloadBtn":"section2_downloadBtn__Cv0_Q","link":"section2_link__rPhrB","wrapper":"section2_wrapper__4fgi8","useCase":"section2_useCase__Gd8N2","section2":"section2_section2__CIzdG"};

/***/ }),

/***/ 352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"section3_card__OwW9_","primaryColor":"section3_primaryColor__a973r","button":"section3_button__ma8iz","section3":"section3_section3__EDqya"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [737,466,6,162,411,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);